import React, {
  createContext,
  PropsWithChildren,
  useCallback,
  useContext,
  useState,
} from "react";

type CheckoutBookingAssessmentContextType = {
  bookingData: any;
  onChangeBookingData: (value: any) => void;
};

const CheckoutBookingAssessmentContext = createContext<
  CheckoutBookingAssessmentContextType | undefined
>(undefined);

export const CheckoutBookingAssessmentProvider = (props: PropsWithChildren) => {
  const [bookingData, setBookingData] = useState<any>(null);

  const onChangeBookingData = useCallback((value: any) => {
    setBookingData(value);
  }, []);

  return (
    <CheckoutBookingAssessmentContext.Provider
      value={{
        bookingData,
        onChangeBookingData,
      }}
    >
      {props.children}
    </CheckoutBookingAssessmentContext.Provider>
  );
};

export const useCheckoutBookingAssessment = () => {
  const ctx = useContext(CheckoutBookingAssessmentContext);
  if (!ctx)
    throw new Error(
      "useBookingAssessment must be used within a CheckoutBookingAssessmentProvider"
    );
  return ctx;
};
